import { TFunction } from "i18next";
import { useTranslation as use18nTranslation } from "react-i18next";
import { useBranding } from "./useBranding";

export const useTranslation = (namespace?: string) => {
  const { t, i18n } = use18nTranslation(namespace);
  const { brand, brandName, appDomain } = useBranding();
  const defaultParams = { brand, brandName, appDomain };

  const customT = (key, params = {}) => {
    return t(key, { ...defaultParams, ...params });
  };

  return { t: customT as TFunction, i18n };
};
